import React from 'react';

import { DropdownFavoriteOptionIcon } from 'components/pages/ModeReports/DropdownFavoriteOptionIcon/DropdownFavoriteOptionIcon';

import ReportMultiSelectBase from './ReportMultiSelectBase';

const ReportMultiSelectFilter = ({ setOptionsAsFavorite, favoriteOptions, ...rest }) => {
  const customOptionTemplateFunction = option => (
    <>
      <div style={{ display: 'flex', flexGrow: 1 }}>{option.name}</div>
      <DropdownFavoriteOptionIcon
        setOptionsAsFavorite={setOptionsAsFavorite}
        option={option}
        favoriteOptions={favoriteOptions}
      />
    </>
  );

  return (
    <ReportMultiSelectBase
      {...rest}
      favoriteOptions={favoriteOptions}
      setOptionsAsFavorite={setOptionsAsFavorite}
      customOptionTemplateFunction={customOptionTemplateFunction}
    />
  );
};

export default ReportMultiSelectFilter;
